import Typography from 'typography';

const typography = new Typography({
  baseFontSize: '16px',
  headerFontFamily: [
    'Comfortaa',
    'Helvetica Neue',
    'Segoe UI',
    'Helvetica',
    'Arial',
    'sans-serif',
  ],
  bodyFontFamily: ['Open Sans', 'Georgia', 'serif'],
});

export default typography;



// WEBPACK FOOTER //
// ./src/utils/typography.js